import { Injectable } from '@angular/core';
import type { OperationTypeFindPageQueryInterface } from '@zaoblako/shared/modules/document/dtos/operation-type/operation-type-find-page-query.dto';
import type { OperationTypeFindInterface } from '@zaoblako/shared/modules/document/dtos/operation-type/operation-type-find.dto';
import type { OperationTypeItemsPageInterface } from '@zaoblako/shared/modules/document/dtos/operation-type/operation-type-items-page.dto';
import type { OperationTypePageInterface } from '@zaoblako/shared/modules/document/dtos/operation-type/operation-type-page.dto';
import type { OperationTypeRegistryQueryInterface } from '@zaoblako/shared/modules/document/dtos/operation-type/operation-type-registry-query.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OperationTypeService extends BaseService implements DirectoryHistoryServiceInterface {
  protected baseUrl = '/basis/catalog/operation-type';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(
    queryParams?: OperationTypeRegistryQueryInterface | OperationTypeFindPageQueryInterface
  ): Observable<OperationTypeItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<OperationTypeItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public findWithPagination(queryParams?: OperationTypeFindPageQueryInterface): Observable<OperationTypePageInterface> {
    return this.findPage(queryParams).pipe(
      map((page) => ({
        limit: page.limit,
        offset: page.offset,
        count: page.count,
        items: page.items as OperationTypeFindInterface[]
      }))
    );
  }

  public restoreOne(id: number): Observable<OperationTypeFindInterface> {
    return this.http.post<OperationTypeFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public makeForUndistributed(id: number): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}/for-undistributed`, {});
  }

  public dropForUndistributed(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}/for-undistributed`);
  }
}
